import styles from './hooks.module.css';

import React, { useEffect, useState } from 'react';
import { isImpersonating } from '../helpers/AuthHelpers';
import { isNullOrEmpty } from '../helpers/ObjectHelpers';
import { useConfiguration } from "components/hooks/useAppStore";

export const useImpersonateClassName = () => {

    const [impersonateClassName, setImpersonateClassName] = useState("");

    const configuration = useConfiguration();

    useEffect(() => {
        if(!configuration || !isImpersonating()) return;

        if(!isNullOrEmpty(configuration.environment)){
            // dev
            setImpersonateClassName(styles.impersonateDev);
        } else {
            // production
            setImpersonateClassName(styles.impersonateProd);
        }

    }, [configuration]);

    return impersonateClassName;
}
